export default "__VITE_PUBLIC_ASSET__08799dcc__"